import { Link, useNavigate, useParams } from "react-router-dom";
import WebLayout from "../../../layout/WebLayout";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../stores";
import { useCallback, useEffect, useRef, useState } from "react";
import RegistrationAction from "../../../stores/actions/registrationAction";
import POSAction from "../../../stores/actions/POSAction";
import { toast } from "react-toastify";
import Select from "react-select";
import UpdatePOSCart from "../../../components/UpdatePOSCart";
import { CART, LOGO } from "../../../utils/Constants";
import ProductModel from "../../../components/ProductModel";

function PosPage() {
  const dispatch = useDispatch<any>();
  const [search, setSearch] = useState<any>();
  const limit = 20;
  const [page, setPage] = useState<number>(0);
  const scrollableDivRef = useRef<any>(null);
  const [productId, setProductId] = useState<number>();
  const [slug, setSlug] = useState<string>();
  const [productModal, setProductModal] = useState<boolean>(false);

  const {
    sellerWiseProductList,
    cartList,
    totalQty,
    totalTax,
    totalAmount,
    totalPV,
    deliveryCharge,
  } = useSelector((state: RootState) => state.pos);

  const getPOSProductList = useCallback(async () => {
    try {
      await dispatch(
        POSAction.getSellerWiseProductList({
          search: search,
          limit: limit,
          page: page,
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, [dispatch, search, limit, page]);

  const { myBuyerList } = useSelector(
    (state: RootState) => state.mangeRegistration
  );
  const getBSList = useCallback(async () => {
    await dispatch(
      RegistrationAction.getMyBuyerList({
        search: search,
        limit: limit,
      })
    );
  }, [dispatch, search, limit]);

  useEffect(() => {
    getPOSProductList();
    getBSList();
  }, [getPOSProductList, getBSList, search, limit, page]);

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const buyerOptions: any = myBuyerList?.map((buyer: any) => {
    return {
      value: buyer.id,
      label: buyer.mobile,
    };
  });

  const [userId, setUserId] = useState<any>();
  const handleSubmit = async (
    productId: number,
    slug: string,
    qty: number,
    isVariant: string
  ) => {
    if (isVariant === "YES") {
      if (!userId) {
        toast.error("Please select buyer");
      } else {
        setProductModal(true);
        setProductId(productId);
        setSlug(slug);
      }
      return false;
    }

    if (!userId) {
      toast.error("Please select buyer");
    } else {
      try {
        await dispatch(
          POSAction.addCart({
            product_id: productId,
            user_id: userId?.value,
            size: "",
            color: "",
            isVariant: "",
          })
        );
        toast.success("Added to Cart");
        getCartDataList();
      } catch (e: any) {
        toast.error(e.message);
      }
    }
  };

  const getCartDataList = useCallback(async () => {
    await dispatch(
      POSAction.getCartList({
        user_id: userId?.value,
      })
    );
  }, [dispatch, userId]);

  useEffect(() => {
    getCartDataList();
  }, [getCartDataList]);

  const removeCart = async (id: number) => {
    try {
      await dispatch(
        POSAction.removeCartItem({
          id: id,
        })
      );
      toast.error("Removed cart item");
      getCartDataList();
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = scrollableDivRef.current;
    const bottomReached = scrollTop + clientHeight >= 800;

    if (bottomReached) {
      // You can trigger an alert here or perform any other action you want
      setPage(page + 20);
    }
  };

  const navigate = useNavigate();

  const routeParams = useParams();
  const { id, price }: any = routeParams;

  const [loader, setLoader] = useState<boolean>(false);

  const formHandleSubmit = async (e: any) => {
    setLoader(true);
    e.preventDefault();
    try {
      await dispatch(
        POSAction.createOrder({
          user_id: userId?.value,
          deliveryCharge: deliveryCharge,
        })
      );
      navigate("/po-list/accepted");
      setLoader(false);
    } catch (error: any) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  const removeAllCartItems = async (e: any) => {
    setLoader(true);
    e.preventDefault();
    try {
      await dispatch(
        POSAction.removeAllItem({
          user_id: userId?.value,
        })
      );
      setLoader(false);
    } catch (error: any) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  return (
    <div
      className="content-wrapper zoom"
      style={{
        position: "fixed",
        top: "0px",
        width: "100%",
        height: "100vh",
        zIndex: "9",
      }}>
      <nav className="navbar navbar-expand-xl navbar-detached justify-content-between align-items-center m-1 p-1">
        <div className="navbar-brand d-flex align-items-center">
          <img src={LOGO} alt="logo" width={40} />
          <span className="logo-text">AMSME</span>
        </div>
        <div className="goToBack">
          <Link className="btn btn-primary" to="/">
            <i className="fa fa-arrow-left"></i>&nbsp; Go to Dashboard
          </Link>
        </div>
        <div className="cartCount">
          <div className="position-relative" style={{ border: "none" }}>
            <i
              className="fa fa-shopping-cart"
              style={{ fontSize: "30px", color: "#111" }}></i>{" "}
            <span className="position-absolute top-0">
              <span
                className="badge bg-danger rounded-circle"
                style={{ fontSize: "10px" }}>
                {totalQty}
              </span>
            </span>
          </div>
        </div>
      </nav>
      {productModal && (
        <ProductModel
          setProductModal={setProductModal}
          productModal={productModal}
          productId={productId}
          slug={slug}
          userId={userId?.value}
          getCartDataList={getCartDataList}
        />
      )}
      <div className="container-fluid flex-grow-1 py-1 px-1">
        <div className="">
          <div className="px-2">
            <div className="card-datatable">
              <div className={"row"}>
                <div className={"col-md-7 px-0 py-0"}>
                  <div className="p-0">
                    <div className="row">
                      <div className="input-group gx-1 ">
                        <span
                          className="input-group-text"
                          style={{ borderRadius: "0px" }}>
                          <i className="fa fa-search"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          style={{ borderRadius: "0px" }}
                          value={search}
                          onChange={handleSearch}
                          placeholder="Search product by bar code and product code"></input>
                      </div>
                    </div>
                    <div
                      className={"row"}
                      ref={scrollableDivRef}
                      onScroll={handleScroll}
                      style={{ height: "100vh", overflowY: "scroll" }}>
                      {sellerWiseProductList &&
                        sellerWiseProductList.map((item: any) => {
                          return (
                            <div
                              className="col-sm-6 gx-1 gy-1"
                              style={{ width: "20%" }}
                              onClick={() =>
                                handleSubmit(
                                  item.id,
                                  item.product_slug,
                                  item.min_sale_qty,
                                  item.is_variant
                                )
                              }>
                              <div
                                className="card shadow-none border"
                                style={{
                                  borderRadius: 0,
                                  cursor: "pointer",
                                }}>
                                <div className="discount">
                                  {item.discount}% <br />
                                  off
                                </div>
                                <div className="card-body p-3 pt-2 d-flex justify-content-between flex-column">
                                  <div className="rounded-2 text-center">
                                    <img
                                      className="img-fluid"
                                      src={item.product_image}
                                      alt={item.product_name}
                                      width={150}
                                      style={{
                                        height: 100,
                                        objectFit: "contain",
                                      }}
                                    />
                                    <br />
                                    <p
                                      title={item.product_name}
                                      className={"mb-0 text-field"}
                                      style={{
                                        fontSize: 12,
                                        fontWeight: "bold",
                                      }}>
                                      {item.product_name}
                                    </p>
                                    <p className={"text-success mb-0"}>
                                      Rs. {item.selling_price}
                                    </p>
                                    <p className="badge bg-label-primary mt-2 mb-0">
                                      {item.product_code}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>

                <div className={"col-md-5 px-0 "}>
                  <div className="p-0">
                    <div className="row">
                      <Select
                        classNamePrefix="mySelect"
                        value={userId}
                        onChange={setUserId}
                        options={buyerOptions}
                        placeholder={"Select Buyer"}
                      />
                      <div className="card p-0">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100vh",
                          }}>
                          <div
                            className="table-responsive"
                            style={{ flex: "1 1 auto", overflowY: "auto" }}>
                            <table className="table">
                              <thead>
                                <tr className="table-success">
                                  <th className="text-dark">Item</th>
                                  <th className="text-dark">Price</th>
                                  <th className="text-dark">Qty</th>
                                  <th className="text-dark">Subtotal</th>
                                  <th className="text-dark">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {cartList.length > 0 ? (
                                  cartList.map((item: any) => (
                                    <tr key={item.id}>
                                      <td>
                                        <div className="item-name bg-warning rounded p-1 text-white">
                                          {item.product_name}
                                        </div>
                                        {item?.color ? (
                                          <span className="text-primary">
                                            Color: {item?.color}&nbsp;&nbsp;
                                          </span>
                                        ) : null}

                                        {item?.size ? (
                                          <span className="text-success">
                                            Size: {item?.size}
                                          </span>
                                        ) : null}
                                      </td>
                                      <td className="text-center">
                                        <div className="item-price">
                                          {item.base_price}
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <UpdatePOSCart
                                          productId={item.product_id}
                                          cartQty={item.qty}
                                          cartData={getCartDataList}
                                          minSaleQty={item.min_sale_qty}
                                        />
                                      </td>
                                      <td className="text-center">
                                        <div className="item-price">
                                          {item.base_price * item.qty}
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <div
                                          className="item-action"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => removeCart(item.id)}>
                                          <i
                                            className="bx bx-trash me-1 text-danger"
                                            style={{ fontSize: "24px" }}></i>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5}>
                                      <div className="cartImage">
                                        <img
                                          src={CART}
                                          width={"100%"}
                                          className="rounded mx-auto d-block"
                                          style={{
                                            width: 200,
                                            height: 200,
                                            padding: 20,
                                            objectFit: "contain",
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="summary" style={{ flexShrink: 0 }}>
                            <table className="table">
                              <tbody>
                                <tr>
                                  <td>
                                    <span className="fw-bold">Total PV</span>
                                  </td>
                                  <td className="text-end">
                                    <span className="fw-bold">
                                      {totalPV.toFixed(2)}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span className="fw-bold">Sub Total</span>
                                  </td>
                                  <td className="text-end">
                                    <span className="fw-bold">
                                      {(totalAmount - totalTax).toFixed(2)}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span className="fw-bold">Total Tax</span>
                                  </td>
                                  <td className="text-end">
                                    <span className="fw-bold">
                                      {totalTax.toFixed(2)}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span className="fw-bold">
                                      Delivery Charge
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <span className="fw-bold">
                                      {deliveryCharge.toFixed(2)}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span className="fw-bold">Grand Total</span>
                                  </td>
                                  <td className="text-end">
                                    <span className="fw-bold">
                                      {(totalAmount + deliveryCharge).toFixed(
                                        2
                                      )}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="btn-fix" style={{ flexShrink: 0 }}>
                            <div className="group-btn d-flex justify-content-between">
                              <button
                                onClick={removeAllCartItems}
                                type="submit"
                                className="btn btn-danger w-50"
                                style={{ borderRadius: "0px" }}
                                disabled={loader}>
                                {loader ? (
                                  <i className={"fa fa-spinner fa-spin"}></i>
                                ) : null}
                                <i
                                  className="bx bx-trash me-1 text-white"
                                  style={{ fontSize: "20px" }}></i>{" "}
                                Clear All
                              </button>

                              <button
                                onClick={formHandleSubmit}
                                type="submit"
                                className="btn btn-success w-50"
                                style={{ borderRadius: "0px" }}
                                disabled={loader}>
                                {loader ? (
                                  <i className={"fa fa-spinner fa-spin"}></i>
                                ) : null}
                                <i
                                  className="bx bx-box me-1 text-white"
                                  style={{ fontSize: "20px" }}></i>{" "}
                                Order Generate
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PosPage;
